export const getters = {
  getModalViewPurchase: state => state.modalViewPurchase,
  getModalViewPurchaseActive: state => state.modalViewPurchaseActive,
  getPurchases: state => state.purchases,
  getPurchase: state => state.purchase
};

export default {};
